import React, { Component } from 'react';
//import Button from "react-bootstrap/Button";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import 'react-toastify/dist/ReactToastify.css';
import './dialog.css';
import Cookie from 'js-cookie';
import axios from 'axios';
import { Config } from '../../../config/config';
// import { ThemeProvider } from '@mui/material/styles'; commented as it might be required check once
import Spinner from '../../../UIComponents/Spinner/Spinner';
import { ApiGateWay } from '../../../ApiGateWay/ApiGateWay';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import './dialog.css';

const config = JSON.parse(Config);

function dateFormat(d) {
  let date = new Date(d);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let dt = date.getDate();
  let fDate = '';
  if (dt < 10) {
    dt = '0' + dt;
  }
  if (month < 10) {
    month = '0' + month;
  }
  fDate = dt + '-' + month + '-' + year;
  return fDate;
}

class ArchiveDialog extends Component {
  constructor(props) {
    super(props);

    const config = JSON.parse(Config);
    //  const userInfo = JSON.parse(Cookie.get("currentUser"));

    this.state = {
      o: false,
      storeId: props.storeId,
      documentPath: '',
      config,
      proxyjson: [],
      documentType: '',
      documentId: props.documentId,
      documentName: '',
      url: props.url,
      loading: false,
    };
  }

  fileDownload = async (documentPath) => {
    this.setState({
      loading: true,
    });
    let headers = {
      Authorization: 'Bearer ' + JSON.parse(Cookie.get('token')),
      'Access-Control-Allow-Origin': '*',
      'x-api-key': process.env.REACT_APP_X_API_KEY,
    };
    axios
      .get(
        process.env.REACT_APP_UPLOAD_DOWNLOAD +
          config['api'] +
          '/download?objectId=' +
          documentPath,
        {
          headers: headers,
          responseType: 'blob',
        }
      )
      .then((response) => {
        //Create a Blob from the PDF Stream

        var re = /(?:\.([^.]+))?$/;

        var ext = re.exec(documentPath)[1]; // "txt"
        const MimeTypesMap = {
          png: 'image/png',
          gif: 'image/gif',
          jpg: 'image/jpg',
          jpeg: 'image/jpeg',
          pdf: 'application/pdf',
          mp4: 'video/mp4',
          doc: 'application/msword',
          docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          ppt: 'application/vnd.ms-powerpoint',
          pptx: 'application/vnd.ms-powerpoint',
          xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        };

        const mimeType = MimeTypesMap[ext];

        const file = new Blob([response.data], { type: mimeType });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        //window.open(fileURL);
        if (mimeType === 'application/pdf') {
          window.open(fileURL, '_blank');
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', documentPath); //or any other extension
          document.body.appendChild(link);
          link.click();
        }
        this.setState({
          loading: false,
        });
      })
      .catch((error) => {});
  };

  archiveDocument = () => {
    /*
      Used to get the data in the Archive Dialog. Based on which tab is selected, respective api is called. 
    */

    ApiGateWay.Get(
      this.state.config['api'] +
        this.state.url +
        '?storeId=' +
        this.state.storeId +
        '&documentId=' +
        this.state.documentId
    )
      .then((response) => response.json())
      .then((response) => {
        let body = [];
        let colorCodes = [];
        let proxyjson = [];
        if (this.state.url === '/loadComplianceListArchive') {
          response.compliance[0].documentTypes.map((name, val) => {
            let uDate = name.uploadedDate;
            let exp = name.expiryDate;
            body.push([
              val + 1,
              <a
                onClick={() => this.fileDownload(name.documentPath)}
                style={{ cursor: 'pointer' }}
              >
                {name.documentType}
              </a>,
              uDate,
              exp,
              name.uploadedBy,
            ]);

            colorCodes.push([0, 0, 0, 0, 0, 0]);
            this.setState({
              documentName: name.documentType,
            });
            proxyjson = {
              type: 'Archive',
              thead: [
                'Sl No.',
                'Document Name',
                'Upload Date',
                'Expiry Date',
                'Uploaded By',
              ],
              tbody: body,
              columns: [
                'Sl No.',
                'Document Name',
                'Upload Date',
                'Expiry Date',
                'Uploaded By',
              ],
              colorCodes: colorCodes,
            };
          });
        } else {
          response.contracts[0].documentTypes.map((name, val) => {
            let uDate = name.uploadedDate;
            let exp = name.expiryDate;
            body.push([
              val + 1,
              <a
                onClick={() => this.fileDownload(name.documentPath)}
                style={{ cursor: 'pointer' }}
              >
                {name.vendorName}
              </a>,
              uDate,
              exp,
              name.uploadedBy,
            ]);

            colorCodes.push([0, 0, 0, 0, 0, 0]);
            this.setState({
              documentName: name.documentType,
            });
            proxyjson = {
              type: 'Archive',
              thead: [
                'Sl No.',
                'Vendor Name',
                'Upload Date',
                'Expiry Date',
                'Uploaded By',
              ],
              tbody: body,
              columns: [
                'Sl No.',
                'Vendor Name',
                'Upload Date',
                'Expiry Date',
                'Uploaded By',
              ],
              colorCodes: colorCodes,
            };
          });
        }
        this.state.proxyjson = proxyjson;

        this.setState({
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
      });
  };

  handleClickOpen = () => {
    this.setState({
      o: true,
      loading: true,
    });
    this.archiveDocument();
  };

  handleClose = () => {
    this.setState({
      o: false,
    });
  };

  render() {
    //
    const { loading } = this.state;
    return (
      <>
        {loading ? (
          <Spinner />
        ) : (
          // <ThemeProvider injectFirst>
            <div className='row'>
              <div className='col-md-12 test'>
                <div>
                  <a
                    onClick={this.handleClickOpen}
                    style={{ cursor: 'pointer' }}
                  >
                    {' '}
                    View Archive{' '}
                  </a>
                </div>
                <div>
                  <Dialog
                    className='ArchiveDialog'
                    open={this.state.o}
                    onClose={this.handleClose}
                    aria-labelledby='form-dialog-title'
                  >
                    <DialogTitle
                      className='ArchiveTitle'
                      style={{ fontSize: '1.7vh', height: '40px' }}
                      id='form-dialog-title'
                    >
                      <p style={{ fontSize: '', height: '40px' }}>
                        {' '}
                        Document Archive - {this.state.documentName}
                      </p>
                      <IconButton
                        aria-label='close'
                        style={{
                          marginTop: ' -64px',
                          marginRight: '-15px',
                          float: 'right',
                        }}
                        onClick={this.handleClose}
                      >
                        <CloseIcon />
                      </IconButton>{' '}
                    </DialogTitle>

                    <DialogContent>
                      {this.state.proxyjson.length == 0 ? (
                        <p>No Archive Available</p>
                      ) : (
                        <></>
                      )}

                      <table
                        style={{ minWidth: '100%', fontSize: '1.7vh' }}
                        className='table table-bordered table-striped mainGrid col-md-12'
                        id='DataGrid'
                      >
                        <thead
                          style={{
                            background: 'rgb(60, 141, 188)',
                            color: '#fff',
                          }}
                        >
                          <tr>
                            {this.state.proxyjson.thead
                              ? this.state.proxyjson.thead.map((val, index) => (
                                  <th key={val + index}>{val} </th>
                                ))
                              : null}
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.proxyjson.tbody
                            ? this.state.proxyjson.tbody.map((data2, ind) => {
                                return (
                                  <tr key={data2 + ind}>
                                    {data2.map((data3) => (
                                      <td>{data3}</td>
                                    ))}
                                  </tr>
                                );
                              })
                            : null}
                        </tbody>
                      </table>
                    </DialogContent>
                  </Dialog>
                </div>
              </div>
            </div>
          // </ThemeProvider>
        )}
      </>
    );
  }
}

export default ArchiveDialog;
